export default "__VITE_ASSET__D2BZQ1Ru__"